// extracted by mini-css-extract-plugin
module.exports = {"option-item":"_99551c8aa8--option-item--npxk1","tooltip-content":"_99551c8aa8--tooltip-content--GUOqk"};